// Dev-only interop shim, NOT a copied template file — see the note in ../../vite.config.ts.
// react-use's useWindowScroll is a TypeScript-compiled CommonJS module with esModuleInterop
// (`exports.default = fn`, `__esModule: true`). Vite 8's Rolldown pre-bundler re-exports the
// whole CJS `exports` object as this chunk's own `default` rather than unwrapping one level,
// so packages/theme/src/hooks/use-*.ts's `export { default as useWindowScroll } from 'react-use/lib/useWindowScroll'`
// (a copied file — FR-004 forbids editing it) resolves to an object instead of a function.
// This does the unwrap ourselves. vite.config.ts's steelyard-react-use-interop-shims plugin
// redirects that copied file's import here; THIS file's own identical-looking import below is
// left alone by that plugin (it only redirects when the importer is outside this directory), so
// it resolves normally and still gets pre-bundled/CJS-transformed like any other bare import.
import * as mod from "react-use/lib/useWindowScroll";
const value = (mod as { default?: unknown }).default;
const fn = (value && typeof value === "object" && "default" in (value as object)
  ? (value as { default: unknown }).default
  : value) as typeof import("react-use/lib/useWindowScroll")["default"];
export default fn;
